import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export var initialState = {
  activePanel: null,
  lastActivePanel: null,
  isOpen: false,
  panels: {},
  // Whenever these change, they will be run with `useLayoutEffect`. This allows
  // us to call arbitrary functions after state changes, since the reducer
  // itself must be pure.
  effects: []
};
export default function reducer(state, action) {
  switch (action.type) {
    case 'open':
      {
        if (!state.isOpen) {
          // If no panel is selected, select the first one.
          var activePanel = state.activePanel || state.lastActivePanel || Object.keys(state.panels).find(id => state.panels[id] != null) || null;
          var effects = [];

          if (activePanel) {
            var panel = state.panels[activePanel];

            if (panel && panel.onActivate) {
              effects.push(() => panel.onActivate());
            }
          }

          return _objectSpread(_objectSpread({}, state), {}, {
            isOpen: true,
            activePanel,
            lastActivePanel: activePanel,
            effects
          });
        }

        return state;
      }

    case 'close':
      if (state.isOpen) {
        return _objectSpread(_objectSpread({}, state), {}, {
          isOpen: false,
          activePanel: null,
          effects: []
        });
      }

      return state;

    case 'activate':
      {
        var _panel = state.panels[action.panel];
        var _effects = [];

        if (_panel && _panel.onActivate) {
          _effects.push(() => _panel.onActivate(action.state));
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          isOpen: true,
          activePanel: action.panel,
          lastActivePanel: action.panel,
          effects: _effects
        });
      }

    case 'register':
      {
        var _effects2 = []; // It's possible that a panel is re-registering itself after changing some
        // of its properties (like the icon, `onActivate`, etc.). So it could
        // already be the active panel.

        if (state.activePanel === action.panel.id && action.panel.onActivate) {
          _effects2.push(() => action.panel.onActivate());
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          panels: _objectSpread(_objectSpread({}, state.panels), {}, {
            [action.panel.id]: action.panel
          }),
          effects: _effects2
        });
      }

    case 'unregister':
      {
        var _activePanel = state.activePanel;

        if (_activePanel === action.id) {
          _activePanel = Object.keys(state.panels).find(id => state.panels[id] != null && id !== action.id) || null;
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          activePanel: _activePanel,
          lastActivePanel: _activePanel,
          panels: _objectSpread(_objectSpread({}, state.panels), {}, {
            [action.id]: null
          }),
          effects: []
        });
      }

    default:
      throw new Error("Unknown action: ".concat(action.type));
  }
}